// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file ChatContext.tsx
 * @input Uses React createContext
 * @output Exports ChatMessageContext for sharing sender/density between Chat components
 * @position Internal context; consumed by ChatMessage and ChatMessageBubble
 */
import { createContext, use } from 'react';
export const ChatMessageContext = /*#__PURE__*/createContext(null);
ChatMessageContext.displayName = 'ChatMessageContext';
export function useChatMessageContext() {
  return use(ChatMessageContext);
}
export const ChatListContext = /*#__PURE__*/createContext(null);
ChatListContext.displayName = 'ChatListContext';
export function useChatListContext() {
  return use(ChatListContext);
}

// =============================================================================
// Composer context — shared state between ChatComposer and ChatComposerInput
// =============================================================================

export const ChatComposerContext = /*#__PURE__*/createContext(null);
ChatComposerContext.displayName = 'ChatComposerContext';
export function useChatComposerContext() {
  return use(ChatComposerContext);
}

// =============================================================================
// Layout context — shared between ChatLayout and ChatMessageList
// =============================================================================

export const ChatLayoutContext = /*#__PURE__*/createContext(null);
ChatLayoutContext.displayName = 'ChatLayoutContext';
export function useChatLayoutContext() {
  return use(ChatLayoutContext);
}